export default __webpack_public_path__ + "static/media/oracle.2d11c42e.svg";